<script>
import Page from '~/components/CMS/Page';

export default {
  ...Page,
  nuxtI18n: {
    paths: {
      en: '/terms-of-sales',
      fr: '/cgv',
    },
  },

  async asyncData({ app, route }) {
      const slug    = route.path.split('/').pop();
      const content = await app.$content(`${app.i18n.locale}/pages`, slug).fetch();
      const data    = { showSocialSharing: false, content: content };
      return data;
  },
};
</script>
